import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_plugin_54604f30 from 'nuxt_plugin_plugin_54604f30' // Source: ./components/plugin.js (mode: 'all')
import nuxt_plugin_recaptcha_01dc8496 from 'nuxt_plugin_recaptcha_01dc8496' // Source: ./recaptcha.js (mode: 'all')
import nuxt_plugin_metaplugin_313b02f5 from 'nuxt_plugin_metaplugin_313b02f5' // Source: ./pwa/meta.plugin.js (mode: 'all')
import nuxt_plugin_iconplugin_35e2a869 from 'nuxt_plugin_iconplugin_35e2a869' // Source: ./pwa/icon.plugin.js (mode: 'all')
import nuxt_plugin_axios_80c87b74 from 'nuxt_plugin_axios_80c87b74' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_rippleplugin369a630f_a46fbf12 from 'nuxt_plugin_rippleplugin369a630f_a46fbf12' // Source: ./ripple.plugin.369a630f.js (mode: 'all')
import nuxt_plugin_multiselectplugin49334080_4ff8d93e from 'nuxt_plugin_multiselectplugin49334080_4ff8d93e' // Source: ./multiselect.plugin.49334080.js (mode: 'all')
import nuxt_plugin_confirmpopupplugin0174944b_25af2a5c from 'nuxt_plugin_confirmpopupplugin0174944b_25af2a5c' // Source: ./confirmpopup.plugin.0174944b.js (mode: 'all')
import nuxt_plugin_columnplugin7f06c8b5_4fe53c72 from 'nuxt_plugin_columnplugin7f06c8b5_4fe53c72' // Source: ./column.plugin.7f06c8b5.js (mode: 'all')
import nuxt_plugin_datatableplugin21535d22_0d4a3fc2 from 'nuxt_plugin_datatableplugin21535d22_0d4a3fc2' // Source: ./datatable.plugin.21535d22.js (mode: 'all')
import nuxt_plugin_passwordplugin0a77b33a_138ef89a from 'nuxt_plugin_passwordplugin0a77b33a_138ef89a' // Source: ./password.plugin.0a77b33a.js (mode: 'all')
import nuxt_plugin_tabpanelplugin000b172e_79b565ab from 'nuxt_plugin_tabpanelplugin000b172e_79b565ab' // Source: ./tabpanel.plugin.000b172e.js (mode: 'all')
import nuxt_plugin_tabviewplugin2bf7a4c5_31c02fe2 from 'nuxt_plugin_tabviewplugin2bf7a4c5_31c02fe2' // Source: ./tabview.plugin.2bf7a4c5.js (mode: 'all')
import nuxt_plugin_overlaypanelpluginb2b79fda_7dc45982 from 'nuxt_plugin_overlaypanelpluginb2b79fda_7dc45982' // Source: ./overlaypanel.plugin.b2b79fda.js (mode: 'all')
import nuxt_plugin_toastplugin00b2171c_5e0a3360 from 'nuxt_plugin_toastplugin00b2171c_5e0a3360' // Source: ./toast.plugin.00b2171c.js (mode: 'all')
import nuxt_plugin_dialogplugin2b73ac27_82ea73ac from 'nuxt_plugin_dialogplugin2b73ac27_82ea73ac' // Source: ./dialog.plugin.2b73ac27.js (mode: 'all')
import nuxt_plugin_galleriaplugin675dc4fe_7eedde06 from 'nuxt_plugin_galleriaplugin675dc4fe_7eedde06' // Source: ./galleria.plugin.675dc4fe.js (mode: 'all')
import nuxt_plugin_paginatorplugin4ff4ea48_2f24a9de from 'nuxt_plugin_paginatorplugin4ff4ea48_2f24a9de' // Source: ./paginator.plugin.4ff4ea48.js (mode: 'all')
import nuxt_plugin_checkboxplugin27bfc262_233a7aae from 'nuxt_plugin_checkboxplugin27bfc262_233a7aae' // Source: ./checkbox.plugin.27bfc262.js (mode: 'all')
import nuxt_plugin_progressspinnerplugin3f93ebd7_dcbe36b4 from 'nuxt_plugin_progressspinnerplugin3f93ebd7_dcbe36b4' // Source: ./progressspinner.plugin.3f93ebd7.js (mode: 'all')
import nuxt_plugin_radiobuttonpluginde87fd90_1efd976d from 'nuxt_plugin_radiobuttonpluginde87fd90_1efd976d' // Source: ./radiobutton.plugin.de87fd90.js (mode: 'all')
import nuxt_plugin_listboxplugin434e19b8_078e8898 from 'nuxt_plugin_listboxplugin434e19b8_078e8898' // Source: ./listbox.plugin.434e19b8.js (mode: 'all')
import nuxt_plugin_accordiontabplugin5dc6626c_a1d6b1e6 from 'nuxt_plugin_accordiontabplugin5dc6626c_a1d6b1e6' // Source: ./accordiontab.plugin.5dc6626c.js (mode: 'all')
import nuxt_plugin_accordionplugin5677795a_004b65d8 from 'nuxt_plugin_accordionplugin5677795a_004b65d8' // Source: ./accordion.plugin.5677795a.js (mode: 'all')
import nuxt_plugin_dropdownplugin61ff3da0_3b567e8e from 'nuxt_plugin_dropdownplugin61ff3da0_3b567e8e' // Source: ./dropdown.plugin.61ff3da0.js (mode: 'all')
import nuxt_plugin_skeletonplugin34a6fa6c_434e1ccc from 'nuxt_plugin_skeletonplugin34a6fa6c_434e1ccc' // Source: ./skeleton.plugin.34a6fa6c.js (mode: 'all')
import nuxt_plugin_configpluginripplef6d7c560_3ee5ec86 from 'nuxt_plugin_configpluginripplef6d7c560_3ee5ec86' // Source: ./config.plugin-ripple.f6d7c560.js (mode: 'all')
import nuxt_plugin_filters_14a52510 from 'nuxt_plugin_filters_14a52510' // Source: ../plugins/filters.js (mode: 'all')
import nuxt_plugin_axios_397e53b5 from 'nuxt_plugin_axios_397e53b5' // Source: ../plugins/axios.js (mode: 'all')
import nuxt_plugin_global_32164e1c from 'nuxt_plugin_global_32164e1c' // Source: ../mixins/global.js (mode: 'all')
import nuxt_plugin_veevalidate_21716614 from 'nuxt_plugin_veevalidate_21716614' // Source: ../plugins/vee-validate.js (mode: 'all')
import nuxt_plugin_messages_ffd92292 from 'nuxt_plugin_messages_ffd92292' // Source: ../plugins/messages.js (mode: 'all')
import nuxt_plugin_componentsclient_99da5530 from 'nuxt_plugin_componentsclient_99da5530' // Source: ../plugins/components.client.js (mode: 'client')
import nuxt_plugin_metapixelclient_3bce0510 from 'nuxt_plugin_metapixelclient_3bce0510' // Source: ../plugins/meta-pixel.client.js (mode: 'client')
import nuxt_plugin_pdfExportclient_496659a0 from 'nuxt_plugin_pdfExportclient_496659a0' // Source: ../plugins/pdfExport.client.js (mode: 'client')
import nuxt_plugin_gsapclient_1690b5a6 from 'nuxt_plugin_gsapclient_1690b5a6' // Source: ../plugins/gsap.client.js (mode: 'client')
import nuxt_plugin_slughintclient_001f5893 from 'nuxt_plugin_slughintclient_001f5893' // Source: ../plugins/slug-hint.client.js (mode: 'client')
import nuxt_plugin_auth_7543862a from 'nuxt_plugin_auth_7543862a' // Source: ./auth.js (mode: 'all')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$app', {
  get() {
    const globalNuxt = this.$root ? this.$root.$options.$app : null
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$app
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const store = createStore(ssrContext)
  const router = await createRouter(ssrContext, config, { store })

  // Add this.$router into store actions/mutations
  store.$router = router

  // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
  store.registerModule = registerModule

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"titleTemplate":"%s - LeisureCraft","title":"LeisureCraft","meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1.0"},{"name":"format-detection","content":"telephone=no"},{"hid":"og:site_name","property":"og:site_name","content":"LeisureCraft"},{"hid":"og:image","property":"og:image","content":"https:\u002F\u002Fleisurecraft.com\u002Fimages\u002Fleisurecraft-default-share.jpg"},{"hid":"twitter:card","name":"twitter:card","content":"summary_large_image"},{"hid":"twitter:image","name":"twitter:image","content":"https:\u002F\u002Fleisurecraft.com\u002Fimages\u002Fleisurecraft-default-share.jpg"},{"name":"apple-mobile-web-app-status-bar-style","content":"#F7F5EE"},{"name":"theme-color","content":"#F7F5EE"},{"name":"apple-mobile-web-app-capable","content":"yes"},{"name":"mobile-web-app-capable","content":"yes"}],"link":[{"rel":"preload","as":"font","type":"font\u002Fwoff2","href":"\u002Ffonts\u002FSatoshi-Variable.woff2","crossorigin":"anonymous"},{"rel":"icon","type":"image\u002Fx-icon","href":"\u002Ffavicon\u002Ffavicon.ico"},{"rel":"icon","type":"image\u002Fpng","sizes":"144x144","href":"\u002Ffavicon\u002Ffavicon-144.png"},{"rel":"apple-touch-startup-image","href":"\u002Fimages\u002Fsplash\u002Fapple-splash-2048-2732.jpg","media":"(device-width: 1024px) and (device-height: 1366px) and (-webkit-device-pixel-ratio: 2) and (orientation: portrait)"},{"rel":"apple-touch-startup-image","href":"\u002Fimages\u002Fsplash\u002Fapple-splash-2732-2048.jpg","media":"(device-width: 1024px) and (device-height: 1366px) and (-webkit-device-pixel-ratio: 2) and (orientation: landscape)"},{"rel":"apple-touch-startup-image","href":"\u002Fimages\u002Fsplash\u002Fapple-splash-1668-2388.jpg","media":"(device-width: 834px) and (device-height: 1194px) and (-webkit-device-pixel-ratio: 2) and (orientation: portrait)"},{"rel":"apple-touch-startup-image","href":"\u002Fimages\u002Fsplash\u002Fapple-splash-2388-1668.jpg","media":"(device-width: 834px) and (device-height: 1194px) and (-webkit-device-pixel-ratio: 2) and (orientation: landscape)"},{"rel":"apple-touch-startup-image","href":"\u002Fimages\u002Fsplash\u002Fapple-splash-1536-2048.jpg","media":"(device-width: 768px) and (device-height: 1024px) and (-webkit-device-pixel-ratio: 2) and (orientation: portrait)"},{"rel":"apple-touch-startup-image","href":"\u002Fimages\u002Fsplash\u002Fapple-splash-2048-1536.jpg","media":"(device-width: 768px) and (device-height: 1024px) and (-webkit-device-pixel-ratio: 2) and (orientation: landscape)"},{"rel":"apple-touch-startup-image","href":"\u002Fimages\u002Fsplash\u002Fapple-splash-1640-2360.jpg","media":"(device-width: 820px) and (device-height: 1180px) and (-webkit-device-pixel-ratio: 2) and (orientation: portrait)"},{"rel":"apple-touch-startup-image","href":"\u002Fimages\u002Fsplash\u002Fapple-splash-2360-1640.jpg","media":"(device-width: 820px) and (device-height: 1180px) and (-webkit-device-pixel-ratio: 2) and (orientation: landscape)"},{"rel":"apple-touch-startup-image","href":"\u002Fimages\u002Fsplash\u002Fapple-splash-1668-2224.jpg","media":"(device-width: 834px) and (device-height: 1112px) and (-webkit-device-pixel-ratio: 2) and (orientation: portrait)"},{"rel":"apple-touch-startup-image","href":"\u002Fimages\u002Fsplash\u002Fapple-splash-2224-1668.jpg","media":"(device-width: 834px) and (device-height: 1112px) and (-webkit-device-pixel-ratio: 2) and (orientation: landscape)"},{"rel":"apple-touch-startup-image","href":"\u002Fimages\u002Fsplash\u002Fapple-splash-1620-2160.jpg","media":"(device-width: 810px) and (device-height: 1080px) and (-webkit-device-pixel-ratio: 2) and (orientation: portrait)"},{"rel":"apple-touch-startup-image","href":"\u002Fimages\u002Fsplash\u002Fapple-splash-2160-1620.jpg","media":"(device-width: 810px) and (device-height: 1080px) and (-webkit-device-pixel-ratio: 2) and (orientation: landscape)"},{"rel":"apple-touch-startup-image","href":"\u002Fimages\u002Fsplash\u002Fapple-splash-1488-2266.jpg","media":"(device-width: 744px) and (device-height: 1133px) and (-webkit-device-pixel-ratio: 2) and (orientation: portrait)"},{"rel":"apple-touch-startup-image","href":"\u002Fimages\u002Fsplash\u002Fapple-splash-2266-1488.jpg","media":"(device-width: 744px) and (device-height: 1133px) and (-webkit-device-pixel-ratio: 2) and (orientation: landscape)"},{"rel":"apple-touch-startup-image","href":"\u002Fimages\u002Fsplash\u002Fapple-splash-1320-2868.jpg","media":"(device-width: 440px) and (device-height: 956px) and (-webkit-device-pixel-ratio: 3) and (orientation: portrait)"},{"rel":"apple-touch-startup-image","href":"\u002Fimages\u002Fsplash\u002Fapple-splash-2868-1320.jpg","media":"(device-width: 440px) and (device-height: 956px) and (-webkit-device-pixel-ratio: 3) and (orientation: landscape)"},{"rel":"apple-touch-startup-image","href":"\u002Fimages\u002Fsplash\u002Fapple-splash-1206-2622.jpg","media":"(device-width: 402px) and (device-height: 874px) and (-webkit-device-pixel-ratio: 3) and (orientation: portrait)"},{"rel":"apple-touch-startup-image","href":"\u002Fimages\u002Fsplash\u002Fapple-splash-2622-1206.jpg","media":"(device-width: 402px) and (device-height: 874px) and (-webkit-device-pixel-ratio: 3) and (orientation: landscape)"},{"rel":"apple-touch-startup-image","href":"\u002Fimages\u002Fsplash\u002Fapple-splash-1260-2736.jpg","media":"(device-width: 420px) and (device-height: 912px) and (-webkit-device-pixel-ratio: 3) and (orientation: portrait)"},{"rel":"apple-touch-startup-image","href":"\u002Fimages\u002Fsplash\u002Fapple-splash-2736-1260.jpg","media":"(device-width: 420px) and (device-height: 912px) and (-webkit-device-pixel-ratio: 3) and (orientation: landscape)"},{"rel":"apple-touch-startup-image","href":"\u002Fimages\u002Fsplash\u002Fapple-splash-1290-2796.jpg","media":"(device-width: 430px) and (device-height: 932px) and (-webkit-device-pixel-ratio: 3) and (orientation: portrait)"},{"rel":"apple-touch-startup-image","href":"\u002Fimages\u002Fsplash\u002Fapple-splash-2796-1290.jpg","media":"(device-width: 430px) and (device-height: 932px) and (-webkit-device-pixel-ratio: 3) and (orientation: landscape)"},{"rel":"apple-touch-startup-image","href":"\u002Fimages\u002Fsplash\u002Fapple-splash-1179-2556.jpg","media":"(device-width: 393px) and (device-height: 852px) and (-webkit-device-pixel-ratio: 3) and (orientation: portrait)"},{"rel":"apple-touch-startup-image","href":"\u002Fimages\u002Fsplash\u002Fapple-splash-2556-1179.jpg","media":"(device-width: 393px) and (device-height: 852px) and (-webkit-device-pixel-ratio: 3) and (orientation: landscape)"},{"rel":"apple-touch-startup-image","href":"\u002Fimages\u002Fsplash\u002Fapple-splash-1170-2532.jpg","media":"(device-width: 390px) and (device-height: 844px) and (-webkit-device-pixel-ratio: 3) and (orientation: portrait)"},{"rel":"apple-touch-startup-image","href":"\u002Fimages\u002Fsplash\u002Fapple-splash-2532-1170.jpg","media":"(device-width: 390px) and (device-height: 844px) and (-webkit-device-pixel-ratio: 3) and (orientation: landscape)"},{"rel":"apple-touch-startup-image","href":"\u002Fimages\u002Fsplash\u002Fapple-splash-1284-2778.jpg","media":"(device-width: 428px) and (device-height: 926px) and (-webkit-device-pixel-ratio: 3) and (orientation: portrait)"},{"rel":"apple-touch-startup-image","href":"\u002Fimages\u002Fsplash\u002Fapple-splash-2778-1284.jpg","media":"(device-width: 428px) and (device-height: 926px) and (-webkit-device-pixel-ratio: 3) and (orientation: landscape)"},{"rel":"apple-touch-startup-image","href":"\u002Fimages\u002Fsplash\u002Fapple-splash-1125-2436.jpg","media":"(device-width: 375px) and (device-height: 812px) and (-webkit-device-pixel-ratio: 3) and (orientation: portrait)"},{"rel":"apple-touch-startup-image","href":"\u002Fimages\u002Fsplash\u002Fapple-splash-2436-1125.jpg","media":"(device-width: 375px) and (device-height: 812px) and (-webkit-device-pixel-ratio: 3) and (orientation: landscape)"},{"rel":"apple-touch-startup-image","href":"\u002Fimages\u002Fsplash\u002Fapple-splash-1242-2688.jpg","media":"(device-width: 414px) and (device-height: 896px) and (-webkit-device-pixel-ratio: 3) and (orientation: portrait)"},{"rel":"apple-touch-startup-image","href":"\u002Fimages\u002Fsplash\u002Fapple-splash-2688-1242.jpg","media":"(device-width: 414px) and (device-height: 896px) and (-webkit-device-pixel-ratio: 3) and (orientation: landscape)"},{"rel":"apple-touch-startup-image","href":"\u002Fimages\u002Fsplash\u002Fapple-splash-828-1792.jpg","media":"(device-width: 414px) and (device-height: 896px) and (-webkit-device-pixel-ratio: 2) and (orientation: portrait)"},{"rel":"apple-touch-startup-image","href":"\u002Fimages\u002Fsplash\u002Fapple-splash-1792-828.jpg","media":"(device-width: 414px) and (device-height: 896px) and (-webkit-device-pixel-ratio: 2) and (orientation: landscape)"},{"rel":"apple-touch-startup-image","href":"\u002Fimages\u002Fsplash\u002Fapple-splash-1242-2208.jpg","media":"(device-width: 414px) and (device-height: 736px) and (-webkit-device-pixel-ratio: 3) and (orientation: portrait)"},{"rel":"apple-touch-startup-image","href":"\u002Fimages\u002Fsplash\u002Fapple-splash-2208-1242.jpg","media":"(device-width: 414px) and (device-height: 736px) and (-webkit-device-pixel-ratio: 3) and (orientation: landscape)"},{"rel":"apple-touch-startup-image","href":"\u002Fimages\u002Fsplash\u002Fapple-splash-750-1334.jpg","media":"(device-width: 375px) and (device-height: 667px) and (-webkit-device-pixel-ratio: 2) and (orientation: portrait)"},{"rel":"apple-touch-startup-image","href":"\u002Fimages\u002Fsplash\u002Fapple-splash-1334-750.jpg","media":"(device-width: 375px) and (device-height: 667px) and (-webkit-device-pixel-ratio: 2) and (orientation: landscape)"},{"rel":"apple-touch-startup-image","href":"\u002Fimages\u002Fsplash\u002Fapple-splash-640-1136.jpg","media":"(device-width: 320px) and (device-height: 568px) and (-webkit-device-pixel-ratio: 2) and (orientation: portrait)"},{"rel":"apple-touch-startup-image","href":"\u002Fimages\u002Fsplash\u002Fapple-splash-1136-640.jpg","media":"(device-width: 320px) and (device-height: 568px) and (-webkit-device-pixel-ratio: 2) and (orientation: landscape)"}],"script":[{"innerHTML":"\n          if ('serviceWorker' in navigator) {\n            navigator.serviceWorker.getRegistrations().then(function(registrations) {\n              for (let registration of registrations) {\n                registration.unregister()\n              }\n            })\n          }\n        ","type":"text\u002Fjavascript","charset":"utf-8"},{"hid":"meta-pixel","innerHTML":"!function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,document,'script','https:\u002F\u002Fconnect.facebook.net\u002Fen_US\u002Ffbevents.js');fbq('init','1663860595300081');fbq('track','PageView');","type":"text\u002Fjavascript"}],"noscript":[{"hid":"meta-pixel-noscript","innerHTML":"\u003Cimg height=\"1\" width=\"1\" style=\"display:none\" src=\"https:\u002F\u002Fwww.facebook.com\u002Ftr?id=1663860595300081&ev=PageView&noscript=1\"\u002F\u003E"}],"__dangerouslyDisableSanitizers":["script","noscript"],"style":[]},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    beforeSerializeFns: ssrContext ? ssrContext.beforeSerializeFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__app_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__APP__ && window.__APP__.state) {
      store.replaceState(window.__APP__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_plugin_54604f30 === 'function') {
    await nuxt_plugin_plugin_54604f30(app.context, inject)
  }

  if (typeof nuxt_plugin_recaptcha_01dc8496 === 'function') {
    await nuxt_plugin_recaptcha_01dc8496(app.context, inject)
  }

  if (typeof nuxt_plugin_metaplugin_313b02f5 === 'function') {
    await nuxt_plugin_metaplugin_313b02f5(app.context, inject)
  }

  if (typeof nuxt_plugin_iconplugin_35e2a869 === 'function') {
    await nuxt_plugin_iconplugin_35e2a869(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_80c87b74 === 'function') {
    await nuxt_plugin_axios_80c87b74(app.context, inject)
  }

  if (typeof nuxt_plugin_rippleplugin369a630f_a46fbf12 === 'function') {
    await nuxt_plugin_rippleplugin369a630f_a46fbf12(app.context, inject)
  }

  if (typeof nuxt_plugin_multiselectplugin49334080_4ff8d93e === 'function') {
    await nuxt_plugin_multiselectplugin49334080_4ff8d93e(app.context, inject)
  }

  if (typeof nuxt_plugin_confirmpopupplugin0174944b_25af2a5c === 'function') {
    await nuxt_plugin_confirmpopupplugin0174944b_25af2a5c(app.context, inject)
  }

  if (typeof nuxt_plugin_columnplugin7f06c8b5_4fe53c72 === 'function') {
    await nuxt_plugin_columnplugin7f06c8b5_4fe53c72(app.context, inject)
  }

  if (typeof nuxt_plugin_datatableplugin21535d22_0d4a3fc2 === 'function') {
    await nuxt_plugin_datatableplugin21535d22_0d4a3fc2(app.context, inject)
  }

  if (typeof nuxt_plugin_passwordplugin0a77b33a_138ef89a === 'function') {
    await nuxt_plugin_passwordplugin0a77b33a_138ef89a(app.context, inject)
  }

  if (typeof nuxt_plugin_tabpanelplugin000b172e_79b565ab === 'function') {
    await nuxt_plugin_tabpanelplugin000b172e_79b565ab(app.context, inject)
  }

  if (typeof nuxt_plugin_tabviewplugin2bf7a4c5_31c02fe2 === 'function') {
    await nuxt_plugin_tabviewplugin2bf7a4c5_31c02fe2(app.context, inject)
  }

  if (typeof nuxt_plugin_overlaypanelpluginb2b79fda_7dc45982 === 'function') {
    await nuxt_plugin_overlaypanelpluginb2b79fda_7dc45982(app.context, inject)
  }

  if (typeof nuxt_plugin_toastplugin00b2171c_5e0a3360 === 'function') {
    await nuxt_plugin_toastplugin00b2171c_5e0a3360(app.context, inject)
  }

  if (typeof nuxt_plugin_dialogplugin2b73ac27_82ea73ac === 'function') {
    await nuxt_plugin_dialogplugin2b73ac27_82ea73ac(app.context, inject)
  }

  if (typeof nuxt_plugin_galleriaplugin675dc4fe_7eedde06 === 'function') {
    await nuxt_plugin_galleriaplugin675dc4fe_7eedde06(app.context, inject)
  }

  if (typeof nuxt_plugin_paginatorplugin4ff4ea48_2f24a9de === 'function') {
    await nuxt_plugin_paginatorplugin4ff4ea48_2f24a9de(app.context, inject)
  }

  if (typeof nuxt_plugin_checkboxplugin27bfc262_233a7aae === 'function') {
    await nuxt_plugin_checkboxplugin27bfc262_233a7aae(app.context, inject)
  }

  if (typeof nuxt_plugin_progressspinnerplugin3f93ebd7_dcbe36b4 === 'function') {
    await nuxt_plugin_progressspinnerplugin3f93ebd7_dcbe36b4(app.context, inject)
  }

  if (typeof nuxt_plugin_radiobuttonpluginde87fd90_1efd976d === 'function') {
    await nuxt_plugin_radiobuttonpluginde87fd90_1efd976d(app.context, inject)
  }

  if (typeof nuxt_plugin_listboxplugin434e19b8_078e8898 === 'function') {
    await nuxt_plugin_listboxplugin434e19b8_078e8898(app.context, inject)
  }

  if (typeof nuxt_plugin_accordiontabplugin5dc6626c_a1d6b1e6 === 'function') {
    await nuxt_plugin_accordiontabplugin5dc6626c_a1d6b1e6(app.context, inject)
  }

  if (typeof nuxt_plugin_accordionplugin5677795a_004b65d8 === 'function') {
    await nuxt_plugin_accordionplugin5677795a_004b65d8(app.context, inject)
  }

  if (typeof nuxt_plugin_dropdownplugin61ff3da0_3b567e8e === 'function') {
    await nuxt_plugin_dropdownplugin61ff3da0_3b567e8e(app.context, inject)
  }

  if (typeof nuxt_plugin_skeletonplugin34a6fa6c_434e1ccc === 'function') {
    await nuxt_plugin_skeletonplugin34a6fa6c_434e1ccc(app.context, inject)
  }

  if (typeof nuxt_plugin_configpluginripplef6d7c560_3ee5ec86 === 'function') {
    await nuxt_plugin_configpluginripplef6d7c560_3ee5ec86(app.context, inject)
  }

  if (typeof nuxt_plugin_filters_14a52510 === 'function') {
    await nuxt_plugin_filters_14a52510(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_397e53b5 === 'function') {
    await nuxt_plugin_axios_397e53b5(app.context, inject)
  }

  if (typeof nuxt_plugin_global_32164e1c === 'function') {
    await nuxt_plugin_global_32164e1c(app.context, inject)
  }

  if (typeof nuxt_plugin_veevalidate_21716614 === 'function') {
    await nuxt_plugin_veevalidate_21716614(app.context, inject)
  }

  if (typeof nuxt_plugin_messages_ffd92292 === 'function') {
    await nuxt_plugin_messages_ffd92292(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_componentsclient_99da5530 === 'function') {
    await nuxt_plugin_componentsclient_99da5530(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_metapixelclient_3bce0510 === 'function') {
    await nuxt_plugin_metapixelclient_3bce0510(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_pdfExportclient_496659a0 === 'function') {
    await nuxt_plugin_pdfExportclient_496659a0(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_gsapclient_1690b5a6 === 'function') {
    await nuxt_plugin_gsapclient_1690b5a6(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_slughintclient_001f5893 === 'function') {
    await nuxt_plugin_slughintclient_001f5893(app.context, inject)
  }

  if (typeof nuxt_plugin_auth_7543862a === 'function') {
    await nuxt_plugin_auth_7543862a(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
